import React, { useEffect, useState } from "react";
import "../../../../src/slider.css";
import { motion } from "framer-motion";
import NavBarNew from "./navBar";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const scaleFade = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1 },
};

const Slider = ({ heding, paragraph }) => {
  const images = [
    "https://res.cloudinary.com/bsgfcooa/image/upload/v1752140200/couple-workers-standing-garden-near-flowers-talking_1__11zon_ymtzlm.jpg",
    "https://res.cloudinary.com/bsgfcooa/image/upload/v1752140093/fields-greenhouse_11zon_yhsmuw.jpg",
    "https://res.cloudinary.com/bsgfcooa/image/upload/v1752139828/two-researches-man-woman-examine-greenery-with-tablet-all-white-greenhouse_gvbaue.jpg",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="position-relative"
      style={{ width: "100%", height: "100vh", overflow: "hidden" }} // ⬅ use 100vh instead of px
    >
      {/* Blurred Background Image */}
      {/* <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        className="image-background-blur blurred-background"
      /> */}

      {/* Foreground Image */}
      {/* <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex + 1}`}
        className="image-foreground-sharp"
      /> */}
      {/* <NavBarNew></NavBarNew> */}

      <video
        src="https://res.cloudinary.com/bsgfcooa/video/upload/v1752214654/watermarked_preview_muyoxe.mp4"
        className="image-background-blur blurred-background"
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Text Overlay */}
      <div className="slider-text-overlay d-flex justify-content-center align-items-center w-100 h-100 px-3 px-md-5">
        <div className="text-white text-center content-box">
          <motion.h1
            className="display-4 fw-bold text-uppercase mb-4"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.7 }}
            variants={fadeUp}
            transition={{ duration: 0.7 }}
          >
            {/* Naturally Ventilated Polyhouse  */}
            {heding}
          </motion.h1>
          <motion.p
            className="fw-light"
            style={{ fontSize: "18px", fontWeight: 500 }}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: false, amount: 0.3 }}
            variants={fadeUp}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            {paragraph}
            {/* A polyhouse is a type of greenhouse structure made from transparent
            or translucent polyethylene sheets that create a controlled
            environment for plant growth. This protective covering helps
            regulate temperature, humidity, and light, providing optimal growing
            conditions for various crops
           including vegetables, fruits, flowers, and herbs. */}
          </motion.p>
        </div>
      </div>
    </div>
  );
};

export default Slider;
